import { render, staticRenderFns } from "./EMailTemplates.vue?vue&type=template&id=2b669d71&"
import script from "./EMailTemplates.vue?vue&type=script&lang=js&"
export * from "./EMailTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports